import { Injectable } from '@angular/core';
import { BaseService } from './base.service';
import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs';
import { SearchResult } from '../models/generic.model';
import { Contact, JobTitle, Department, ServiceType, JobRole, ExternalPartner } from '../models/people.model';
import { AppSettings } from '../../app.settings';

@Injectable()
export class PeopleService extends BaseService {
    constructor(private http: HttpClient, private config: AppSettings) {
        super();
    }

    getContacts(supplierCode: string): Observable<SearchResult<Contact>> {
        const url = `${this.config.BaseUrl}Profile/People/${supplierCode}/Contact`;
        return this.http.get<SearchResult<Contact>>(url, { headers: this.setHeaders() });
    }

    getJobtitles(supplierCode: string): Observable<JobTitle[]> {
        const url = `${this.config.BaseUrl}Profile/People/${supplierCode}/JobTitle`;
        return this.http.get<JobTitle[]>(url, { headers: this.setHeaders() });
    }

    createJobtitle(supplierCode: string, model: JobTitle): Observable<JobTitle> {
        const url = `${this.config.BaseUrl}Profile/People/${supplierCode}/JobTitle`;
        return this.http.post<JobTitle>(url, model, { headers: this.setHeaders() });
    }

    getDepartments(supplierCode: string): Observable<Department[]> {
        const url = `${this.config.BaseUrl}Profile/People/${supplierCode}/Department`;
        return this.http.get<Department[]>(url, { headers: this.setHeaders() });
    }

    createDepartment(supplierCode: string, model: Department): Observable<Department> {
        const url = `${this.config.BaseUrl}Profile/People/${supplierCode}/Department`;
        return this.http.post<Department>(url, model, { headers: this.setHeaders() });
    }

    getServiceTypes(supplierCode: string): Observable<ServiceType[]> {
        const url = `${this.config.BaseUrl}Profile/People/${supplierCode}/ServiceType`;
        return this.http.get<ServiceType[]>(url, { headers: this.setHeaders() });
    }

    createServiceType(supplierCode: string, model: ServiceType): Observable<ServiceType> {
        const url = `${this.config.BaseUrl}Profile/People/${supplierCode}/ServiceType`;
        return this.http.post<ServiceType>(url, model, { headers: this.setHeaders() });
    }

    getJobRoles(supplierCode: string): Observable<JobRole[]> {
        const url = `${this.config.BaseUrl}Profile/People/${supplierCode}/JobRole`;
        return this.http.get<JobRole[]>(url, { headers: this.setHeaders() });
    }

    createJobRole(supplierCode: string, model: JobRole): Observable<JobRole> {
        const url = `${this.config.BaseUrl}Profile/People/${supplierCode}/JobRole`;
        return this.http.post<JobRole>(url, model, { headers: this.setHeaders() });
    }

    updateJobRole(supplierCode: string, id: number, model: JobRole): Observable<JobRole> {
        const url = `${this.config.BaseUrl}Profile/People/${supplierCode}/JobRole/${id}`;
        return this.http.put<JobRole>(url, model, { headers: this.setHeaders() });
    }

    deleteJobRole(supplierCode: string, id: number): Observable<any> {
        const url = `${this.config.BaseUrl}Profile/People/${supplierCode}/JobRole/${id}`;
        return this.http.delete(url, { headers: this.setHeaders() });
    }

    getExternalPartners(supplierCode: string): Observable<ExternalPartner[]> {
        const url = `${this.config.BaseUrl}Profile/People/${supplierCode}/ExternalPartner`;
        return this.http.get<ExternalPartner[]>(url, { headers: this.setHeaders() });
    }

    createExternalPartner(supplierCode: string, model: ExternalPartner): Observable<ExternalPartner> {
        const url = `${this.config.BaseUrl}Profile/People/${supplierCode}/ExternalPartner`;
        return this.http.post<ExternalPartner>(url, model, { headers: this.setHeaders() });
    }

    updateExternalPartner(supplierCode: string, id: number, model: ExternalPartner): Observable<ExternalPartner> {
        const url = `${this.config.BaseUrl}Profile/People/${supplierCode}/ExternalPartner/${id}`;
        return this.http.put<ExternalPartner>(url, model, { headers: this.setHeaders() });
    }

    deleteExternalPartner(supplierCode: string, id: number): Observable<any> {
        const url = `${this.config.BaseUrl}Profile/People/${supplierCode}/ExternalPartner/${id}`;
        return this.http.delete(url, { headers: this.setHeaders() });
    }
}
